import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';

export default class BlogMember extends PureComponent {
  static propTypes = {
    img: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    roles: PropTypes.string,
    you: PropTypes.string,
    onRemove: PropTypes.func,
  };

  static defaultProps = {
    roles: '',
  };

  render() {
    const {
      img, name, roles, you, onRemove
    } = this.props;

    return (
      <div className="project-member">
        <div className="project-member__avatar-wrap">
          <img src={img} alt="" />
        </div>
        <div>
          <p className="project-member__name">{'@' + name}</p>
          <p className="project-member__post">{roles}</p>
        </div>
        {roles !== 'Owner' && name !== you && <div
          onClick={onRemove}
          className="project-member__btn btn btn-outline-danger btn-sm icon">
          <DeleteOutlineIcon />
        </div>}
      </div>
    );
  }
}
